import { render } from "./SearchElementsModal.vue?vue&type=template&id=8d3d7dee"
import script from "./SearchElementsModal.vue?vue&type=script&lang=ts"
export * from "./SearchElementsModal.vue?vue&type=script&lang=ts"

import "./SearchElementsModal.vue?vue&type=style&index=0&id=8d3d7dee&lang=scss"
script.render = render

export default script